export const NEW_ACTIONS_TEXT = {
	triggerLabel: 'New action',
};
